import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const LandingPageHeadline = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12706"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12706)">
          <rect
            x="-4"
            y="-2"
            width="122"
            height="116"
            rx="5.45069"
            fill="#FFEDBF"
          />
          <path
            d="M94.7627 35.2954V85.0189C94.7627 86.6674 94.1079 88.2483 92.9422 89.4139C91.7766 90.5795 90.1957 91.2344 88.5473 91.2344H29.5006C27.8522 91.2344 26.2712 90.5795 25.1056 89.4139C23.94 88.2483 23.2852 86.6674 23.2852 85.0189V35.2954H94.7627Z"
            fill="#66E1FF"
          />
          <path
            d="M23.2852 35.2954V85.0189C23.2852 86.6674 23.94 88.2483 25.1056 89.4139C26.2712 90.5795 27.8522 91.2344 29.5006 91.2344H32.6083L88.5473 35.2954H23.2852Z"
            fill="#C2F3FF"
          />
          <path
            d="M94.7627 35.2957H23.2852V25.9725C23.2852 24.3241 23.94 22.7432 25.1056 21.5775C26.2712 20.4119 27.8522 19.7571 29.5006 19.7571H88.5473C90.1957 19.7571 91.7766 20.4119 92.9422 21.5775C94.1079 22.7432 94.7627 24.3241 94.7627 25.9725V35.2957Z"
            fill="white"
          />
          <path
            d="M88.5473 19.7571H29.5006C27.8522 19.7571 26.2712 20.4119 25.1056 21.5775C23.94 22.7432 23.2852 24.3241 23.2852 25.9725V85.0192C23.2852 86.6676 23.94 88.2485 25.1056 89.4142C26.2712 90.5798 27.8522 91.2346 29.5006 91.2346H88.5473C90.1957 91.2346 91.7766 90.5798 92.9422 89.4142C94.1079 88.2485 94.7627 86.6676 94.7627 85.0192V25.9725C94.7627 24.3241 94.1079 22.7432 92.9422 21.5775C91.7766 20.4119 90.1957 19.7571 88.5473 19.7571Z"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.2852 35.2954H94.7627"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.1619 28.3034C33.9559 28.3034 33.7583 28.2215 33.6126 28.0758C33.4669 27.9301 33.385 27.7325 33.385 27.5264C33.385 27.3204 33.4669 27.1228 33.6126 26.9771C33.7583 26.8314 33.9559 26.7495 34.1619 26.7495"
            stroke="#191919"
            strokeWidth="1.02201"
          />
          <path
            d="M34.1621 28.3034C34.3682 28.3034 34.5658 28.2215 34.7115 28.0758C34.8572 27.9301 34.939 27.7325 34.939 27.5264C34.939 27.3204 34.8572 27.1228 34.7115 26.9771C34.5658 26.8314 34.3682 26.7495 34.1621 26.7495"
            stroke="#191919"
            strokeWidth="1.02201"
          />
          <path
            d="M14.3962 40.847C14.3962 40.4708 14.7012 40.1657 15.0775 40.1657H64.1339C64.5102 40.1657 64.8152 40.4708 64.8152 40.847V52.2255C64.8152 52.6017 64.5102 52.9068 64.1339 52.9068H15.0775C14.7012 52.9068 14.3962 52.6017 14.3962 52.2255V40.847Z"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.36267"
          />
          <path
            d="M17.3892 44.495V43.8269C17.3892 43.6497 17.4595 43.4798 17.5848 43.3545C17.7101 43.2292 17.88 43.1588 18.0572 43.1588H22.7337C22.9109 43.1588 23.0808 43.2292 23.2061 43.3545C23.3314 43.4798 23.4018 43.6497 23.4018 43.8269V44.495"
            stroke="#1E1E1E"
            strokeWidth="1.36267"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.3953 43.1589V49.1716"
            stroke="#1E1E1E"
            strokeWidth="1.36267"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.0596 49.1715H21.7319"
            stroke="#1E1E1E"
            strokeWidth="1.36267"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.2207 49.5055H31.1591"
            stroke="#1E1E1E"
            strokeWidth="1.36267"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.7108 57.3408H34.4829C34.1851 57.3408 33.8995 57.4591 33.689 57.6697C33.4784 57.8802 33.3601 58.1658 33.3601 58.4636V67.4459C33.3601 67.7437 33.4784 68.0293 33.689 68.2399C33.8995 68.4504 34.1851 68.5687 34.4829 68.5687H45.7108C46.0086 68.5687 46.2942 68.4504 46.5047 68.2399C46.7153 68.0293 46.8336 67.7437 46.8336 67.4459V58.4636C46.8336 58.1658 46.7153 57.8802 46.5047 57.6697C46.2942 57.4591 46.0086 57.3408 45.7108 57.3408Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.7197 57.639L46.4746 68.2696"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.7197 68.2696L46.4746 57.639"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.7108 73.3809H34.4829C34.1851 73.3809 33.8995 73.4992 33.689 73.7097C33.4784 73.9203 33.3601 74.2059 33.3601 74.5036V83.486C33.3601 83.7837 33.4784 84.0693 33.689 84.2799C33.8995 84.4905 34.1851 84.6087 34.4829 84.6087H45.7108C46.0086 84.6087 46.2942 84.4905 46.5047 84.2799C46.7153 84.0693 46.8336 83.7837 46.8336 83.486V74.5036C46.8336 74.2059 46.7153 73.9203 46.5047 73.7097C46.2942 73.4992 46.0086 73.3809 45.7108 73.3809Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.7197 73.679L46.4746 84.3095"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.7197 84.3095L46.4746 73.679"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.4624 58.9451H85.5396"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.4624 65.1602H79.1237"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.4624 71.3762H82.2815"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.4624 77.3403H76.2164"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.4624 83.0049H68.1965"
            stroke="#191919"
            strokeWidth="1.02201"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M43.4852 28.3034C43.2791 28.3034 43.0815 28.2215 42.9358 28.0758C42.7901 27.9301 42.7083 27.7325 42.7083 27.5264C42.7083 27.3204 42.7901 27.1228 42.9358 26.9771C43.0815 26.8314 43.2791 26.7495 43.4852 26.7495"
            stroke="#191919"
            strokeWidth="1.02201"
          />
          <path
            d="M43.4851 28.3034C43.6912 28.3034 43.8888 28.2215 44.0345 28.0758C44.1802 27.9301 44.262 27.7325 44.262 27.5264C44.262 27.3204 44.1802 27.1228 44.0345 26.9771C43.8888 26.8314 43.6912 26.7495 43.4851 26.7495"
            stroke="#191919"
            strokeWidth="1.02201"
          />
          <path
            d="M52.8084 28.3034C52.6024 28.3034 52.4048 28.2215 52.2591 28.0758C52.1133 27.9301 52.0315 27.7325 52.0315 27.5264C52.0315 27.3204 52.1133 27.1228 52.2591 26.9771C52.4048 26.8314 52.6024 26.7495 52.8084 26.7495"
            stroke="#191919"
            strokeWidth="1.02201"
          />
          <path
            d="M52.8083 28.3032C53.0144 28.3032 53.212 28.2214 53.3577 28.0757C53.5034 27.93 53.5853 27.7324 53.5853 27.5263C53.5853 27.3203 53.5034 27.1226 53.3577 26.9769C53.212 26.8312 53.0144 26.7494 52.8083 26.7494"
            stroke="#191919"
            strokeWidth="1.02201"
          />
        </g>
      </SvgIcon>
    );
  })
);
LandingPageHeadline.displayName = 'LandingPageHeadline';
